export function safeParseInt(value: string | number | null | undefined): number | undefined {
	// Value is undefined
	if (value === undefined || value === null) {
		return undefined;
	}

	let parsed: number | undefined;

	// Attempt to parse
	try {
		// Value is already a number
		if (typeof value === 'number') {
			// Mimic the value of parseInt and round down
			parsed = Math.floor(value);
		} else {
			parsed = Number.parseInt(value, 10);
		}
	} catch {
		parsed = undefined;
	}

	// Set to undefined if the value isn't a number
	if (Number.isNaN(parsed)) {
		parsed = undefined;
	}

	// Return the parsed value
	return parsed;
}
